import { createSearchParams } from 'react-router-dom';

import { ApiBasket } from 'src/api/basketService';
import { routes } from 'src/constants/routes';
import { Term } from 'src/shared/types/booking-types';

export const buildRoomsUrl = (
    development: string,
    academicYear: string,
    term?: Pick<Term, 'startDate' | 'duration'>
): string => {
    const searchParams = createSearchParams({ development, academicYear });

    if (term?.startDate && term.duration) {
        searchParams.set('moveInDate', term.startDate);
        searchParams.set('duration', String(term.duration));
    }

    return `${routes.rooms.index}?${searchParams.toString()}`;
};

// STL bookings started from the rooms page, so send them back to their last search. The basket's
// payment options snapshot holds the stay they booked, as the rooms page's query cache won't
// survive the redirect to the booking site
export const getStlRoomsUrl = (
    developmentSlug: string,
    basket?: ApiBasket | null
): string | null => {
    const product = basket?.products[0];
    if (!product?.stl) return null;

    const term =
        basket?.payment_options_snapshot?.find(({ name }) => name === product.term) ??
        basket?.payment_options_snapshot?.[0];

    return buildRoomsUrl(developmentSlug, product.academic_year, term);
};
